import { ref } from 'vue';
import { generateHtmlFromDiff, convertSpaceEntity, convertEditableDomToText, normalizeLineBreaks, normalizeSpaceForLint, removeEmptyLinesAtEnd } from '../utils/helper';
import axios from 'axios';
import { RuleType } from '../@types/rule-type';
import RuleDetailsParser from '../classes/pointer/RuleDetailsParser';
export const useFixPreviewModal = () => {
    const fixStatus = ref({
        fixedRuleLength: 0,
        isFixPreviewOpen: false,
        fixedResult: []
    });
    const openFixPreviewModal = async (inputAreaId, rulePaths, beforeHtmlId, afterHtmlId, userId, ignoreAutoFix, // 未使用。「無視する」を選択したルールIDだが、自動修正はチェックボックスで選択するので、無視するルールIDは不要
    startLoading, endLoading) => {
        const textArea = document.getElementById(inputAreaId);
        if (!textArea)
            return;
        // 自動修正も辞書のpatternと突き合わせるため、校正実行時と同じくNBSPを半角スペースへ戻す
        const text = normalizeSpaceForLint(removeEmptyLinesAtEnd(convertEditableDomToText(textArea)));
        const fixedResult = [];
        const fixCheckBoxes = document.querySelectorAll('.js-fix-flg');
        const applyFixRuleIds = [];
        const applyFixCleintDicIds = [];
        let hasUserDic = false;
        const execFixIds = [];
        const nonFixTxt = [];
        fixCheckBoxes.forEach((_element, index) => {
            const element = _element;
            if (!element.checked)
                return;
            if (element.dataset.lint_type == RuleType.CLIENT_DIC) {
                applyFixCleintDicIds.push(element.dataset.rule_id);
            }
            else if (element.dataset.lint_type == RuleType.USER_DIC) {
                hasUserDic = true;
            }
            else {
                applyFixRuleIds.push(element.dataset.rule_id);
            }
            execFixIds.push(element.dataset.unique_id);
        });
        if (applyFixRuleIds.length < 1 && !hasUserDic && applyFixCleintDicIds.length < 1)
            return;
        startLoading();
        await axios.post(rulePaths.fixLintBaseUrl, {
            ids: applyFixRuleIds, userid: userId, clientDicIds: applyFixCleintDicIds, hasUserDic: hasUserDic
        }).then(res => {
            return axios.post(rulePaths.lintBaseUrl + '/textlint/fix', {
                text: text, userid: userId
            });
        }).then((res) => {
            const applyingRules = res.data.applyingRules;
            const appliedRules = res.data.appliedRules;
            console.log(applyingRules);
            console.log(appliedRules);
            const result = [];
            for (const itemA of applyingRules) {
                let itemB = appliedRules.find((item) => item.index === itemA.index);
                const [message, ruleId, ruleDtlId] = RuleDetailsParser.splitMessageAndDtlId(itemB.message);
                if (!execFixIds.includes(`${ruleId}-${ruleDtlId}`)) {
                    nonFixTxt.push({
                        fixedStr: itemB.fix.text,
                        unfixStr: itemA.fix.text,
                    });
                    continue;
                }
                result.push({
                    beforeText: convertSpaceEntity(itemA.fix.text),
                    afterText: itemB ? convertSpaceEntity(itemB.fix.text) : null,
                    index: itemA.index,
                    ruleId: itemB.ruleId,
                    message: message,
                });
            }
            fixedResult.push(result);
            let fixedText = res.data.fixedText;
            for (const item of nonFixTxt) {
                fixedText = fixedText.replace(item.fixedStr, item.unfixStr);
            }
            fixedText = RuleDetailsParser.removeExpectedIdFromMessage(fixedText);
            const normalizedBeforeText = normalizeLineBreaks(text);
            const normalizedFixedText = normalizeLineBreaks(fixedText);
            const escapeHtml = (str) => str.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            const { beforeHtml, afterHtml } = generateHtmlFromDiff(escapeHtml(normalizedBeforeText), escapeHtml(normalizedFixedText));
            const rule = applyingRules.sort((a, b) => a.index - b.index)
                .reverse()
                .reduce((uniqueRules, currentRule) => {
                const isDuplicate = uniqueRules.some(rule => rule.index === currentRule.index);
                if (!isDuplicate) {
                    uniqueRules.push(currentRule);
                }
                return uniqueRules;
            }, [])
                .reverse();
            const beforeHtmlElement = document.getElementById(beforeHtmlId);
            const afterHtmlElement = document.getElementById(afterHtmlId);
            if (!beforeHtmlElement || !afterHtmlElement)
                return;
            beforeHtmlElement.innerHTML = beforeHtml;
            afterHtmlElement.innerHTML = afterHtml;
            fixStatus.value.fixedRuleLength = rule.length;
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            endLoading();
        });
        fixStatus.value.fixedResult = fixedResult;
        fixStatus.value.isFixPreviewOpen = true;
    };
    const closeFixPreviewModal = () => {
        fixStatus.value.fixedResult = [];
        fixStatus.value.isFixPreviewOpen = false;
        fixStatus.value.fixedRuleLength = 0;
    };
    return {
        fixStatus,
        openFixPreviewModal,
        closeFixPreviewModal
    };
};
